<template>
    <div class="base-card__content program-content">
        <div class="program-content__image-skeleton"/>
        <div>
            <div class="program-content__name-skeleton"/>
            <div class="program-content__time-skeleton"/>
        </div>
    </div>
</template>
